export { default as useBffPostQuery } from './useBffPostQuery';
